// ======================================================================
// File Name       : MessageThreadDetailInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Button, Col } from 'react-bootstrap';

class MessageThreadDetailInfo extends React.Component {
  render() {
    const { messageIdAuto, messageTitle, messageContent, attachmentFileName, messageOperationFlag } = this.props;
    return (
      <div className="col-sm-12">
        <Form className='form-horizontal'>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              スレッドID
            </Col>
            <Col as={Form.Label} sm={7}>{messageIdAuto}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              スレッドタイトル
            </Col>
            <Col as={Form.Label} sm={7}>{messageTitle}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              スレッド詳細
            </Col>
            <Col as={Form.Label} sm={7}>{messageContent}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              添付ファイル
            </Col>
            <Col as={Form.Label} sm={7}>{attachmentFileName}</Col>
          </Form.Group>
        </Form>
        <Form.Group className="form-info margin-top-10">
          <Form.Check
            type='checkbox'
            className="cursor-default margin-left-15"
            name="messageOperationFlag"
            id="messageOperationFlagDetail"
            disabled
            checked={messageOperationFlag}
            label='送信先ユーザーを指定しない'></Form.Check>
        </Form.Group>
      </div>
    );
  }
}

export default MessageThreadDetailInfo;
